import { formatMoney } from '@insify/global-money';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { InvoiceUtils } from '../../utils/invoices';
import { ActionGroup } from '../ActionGroup';
import { StatusBadge } from '../StatusBadge';

import styles from './styles.module.css';

import type { Invoice } from '../../types/Invoice';

export const InvoiceList: React.FC<{ invoices: Invoice[] }> = ({ invoices }) => {
  const { i18n } = useTranslation('common');
  const orderedInvoices = InvoiceUtils.groupAndOrderInvoices(invoices);

  return (
    <div className={styles.container}>
      {orderedInvoices?.map((yearlyGroup) => (
        <div className={styles.yearContainer} key={yearlyGroup.year}>
          <h2>{yearlyGroup.year}</h2>
          {yearlyGroup.months.map((monthlyGroup) => (
            <Fragment key={monthlyGroup.month}>
              <div className={styles.monthContainer}>
                <h3>{InvoiceUtils.getMonthNameByLocale(monthlyGroup.month, i18n.language)}</h3>
                <div className={styles.separator} />
                <div className={styles.monthlyTotal}>{formatMoney(monthlyGroup.total, 'eur')}</div>
              </div>
              <MonthlyInvoices
                trackingIdPrefix={`${yearlyGroup.year}-${monthlyGroup.month}`}
                invoices={monthlyGroup.invoices}
              />
            </Fragment>
          ))}
        </div>
      ))}
    </div>
  );
};

const MonthlyInvoices: React.FC<{ trackingIdPrefix: string; invoices: Invoice[] }> = ({
  trackingIdPrefix,
  invoices,
}) => {
  const displayInvoiceDetail = (url: string) => {
    window.open(url);
  };

  return (
    <ActionGroup.Container>
      {invoices.map((invoice, index) => (
        <ActionGroup.Item
          key={invoice.number}
          trackingId={`invoice-${trackingIdPrefix}-${index}`}
          onClick={() => displayInvoiceDetail(invoice.documentUrl)}
        >
          <div className={styles.invoiceNo}>{invoice.number}</div>
          <div className={styles.invoiceStatus}>
            <StatusBadge.Invoice isPaid={invoice.paid} />
          </div>
          <div className={styles.invoiceAmount}>{formatMoney(invoice.totalAmount, 'eur')}</div>
        </ActionGroup.Item>
      ))}
    </ActionGroup.Container>
  );
};
